import Service from "../../service/index";


const Deathreason = {
    namespaced: true,
    state: {
        deathreason: [],
    },
    mutations: {
        GET_DEATHREASON: (state, data) => {
            state.deathreason = data;
        },

    },
    actions: {
        setDeathreason({commit}){
            return Service.Deathreason.getDeathreason()
                .then(data=>{
                    commit("GET_DEATHREASON",data);
                })
        },
    }
};
export default Deathreason;
